// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-77daa96b] {\n  fill: #fff\n}\n.st139[data-v-77daa96b] {\n  fill: #d7e770\n}\n", ""]);
// Exports
module.exports = exports;
